import React from "react";
import { Banner } from '../../components';
import { FullRealityScroll } from '../../components';
import { Loader } from '../../components';


const FullRealityContainer = (props) => {
  const isFetching = false
  const anello = require("../../assets/full-reality/anello.png");
  const colgate = require("../../assets/full-reality/colgate.png");
  const arrayLoad = [
    anello,
    colgate
  ];
  document.title = "Enter Full Reality with Invrsion"
  return (
    <React.Fragment>
      <FullRealityScroll />
      <Banner 
        text="Inspired? Dive deeper."
        copyRoute="Discover our products"
        route="/products/index"
      />
      <Loader 
        startLoad={false}
        arrayLoad={arrayLoad}
      />
    </React.Fragment>
  );
};

export default FullRealityContainer;
